

























































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Order } from '@/models/order';
import { Product } from '@/models/product';
import u from '@/utility/utility';

@Component
export default class ListProduct extends Vue {
    private eventEmit = {
        eventItemChange: 'eventItemChange',
        eventDeleteItem: 'eventDeleteItem',
    };

    @Prop({ default: () => new Order() })
    private order!: Order;

    get productsQuantity() {
        if (!this.order.products) { return 0; }
        return this.order.products.reduce((acc, curr) => acc + (curr.quantity * 1), 0);
    }

    get totalAmount() {
        if (!this.order.products) { return 0; }
        return this.order.products.reduce((acc, curr) => acc + (curr.amount * 1), 0);
    }

    get totalAmountCN() {
        if (!this.order.products) { return 0; }
        return this.order.products.reduce((acc, curr) => acc + (curr.amountCN * 1), 0);
    }

    private proxyImage(url: string) {
        return u.proxyImage(url);
    }

    private onItemChange(prod: Product) {
        this.$emit(this.eventEmit.eventItemChange, prod);
    }

    private onDeleteItem(prod: Product) {
        this.$emit(this.eventEmit.eventDeleteItem, prod);
    }

    private onQuantityKeyDown(event: any) {
        const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
        if (allowedKeys.includes(event.key)) { return; }
        if (!/^\d$/.test(event.key)) {
            event.preventDefault();
        }
    }
}
